import React, { useContext } from 'react';
import { NewUserRequirementsViewContext } from '../contexts/NewUserRequirementsViewContext';
import { formatText } from 'core/i18n';
import { translations } from './constants';
import './ActionButtons.scss';
import { doTagClickLoginButton, doTagClickStartProcessButton } from '../tagging';

const ActionButtons = () => {
    const { onClickStartProcess, handleToggleProcessAlreadyStartedModal } = useContext(NewUserRequirementsViewContext);

    const handleClickStartProcess = () => {
        doTagClickStartProcessButton();
        onClickStartProcess();
    };

    const handleClickButtonLogin = () => {
        doTagClickLoginButton();
        handleToggleProcessAlreadyStartedModal();
    };

    return (
        <div className="new-user-requirements__buttons">
            <button onClick={handleClickStartProcess} className="form__button form__button-secondary">
                {formatText(translations.BUTTON_PROCEED)}
            </button>
            <button onClick={handleClickButtonLogin} className="form__button form__button-negativeB">
                {formatText(translations.BUTTON_LOGIN)}
            </button>
        </div>
    );
};

export default ActionButtons;
